export default "__VITE_ASSET__DIFudCUx__"